import React, { useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Container } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import AppButton from "../../Components/MerchantButton";
import "./UnifiedFormStyles.css";

function InstallP1TerminalMerch({ navigation, primaryDetails, setPrimaryDetails }) {
  // Use shared state instead of local state
  const formData = {
    standee_installed: primaryDetails.standee_installed || "",
    door_hanger_installed: primaryDetails.door_hanger_installed || "",
    qr_troubleshooting_sticker_installed: primaryDetails.qr_troubleshooting_sticker_installed || "",
    door_sticker_installed: primaryDetails.door_sticker_installed || "",
  };

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPrimaryDetails((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: false }));
  };

  const validate = () => {
    const newErrors = {
      standee_installed: !formData.standee_installed,
      door_hanger_installed: !formData.door_hanger_installed,
      qr_troubleshooting_sticker_installed: !formData.qr_troubleshooting_sticker_installed,
      door_sticker_installed: !formData.door_sticker_installed,
    };
    setErrors(newErrors);
    const hasErrors = Object.values(newErrors).some(Boolean);
    if (hasErrors) {
      toast.error("Please fill in all required fields", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
      return false;
    }
    return true;
  };

  const handleSubmit = (e) => {
  e.preventDefault();
  if (!validate()) return;
  if (primaryDetails.door_sticker_installed === 'Yes') {
    navigation.go('installed-p1-door-sticker');
  } else if (primaryDetails.door_sticker_installed === 'No') {
    navigation.go('not-installed-p1-door-sticker');
  }
};

  const handleBack = () => {
    navigation.previous();
  };

  const Question = ({ label, name }) => (
    <Form.Group className={`mb-4 ${errors[name] ? 'form-group-error' : ''}`}>
      <Form.Label className="form-label">
        {label} <span className="form-required">*</span>
      </Form.Label>
      <div className="form-radio-group">
        {["Yes", "No"].map((option, index) => (
          <div
            key={`${name}-${index}-${option}`}
            className={`form-radio-item${formData[name] === option ? " selected" : ""}`}
          >
            <div className="form-radio-flex">
              <Form.Check
                type="radio"
                id={`${name}-${option}`}
                name={name}
                value={option}
                label={option}
                checked={formData[name] === option}
                onChange={handleChange}
                className="form-radio"
              />
            </div>
          </div>
        ))}
      </div>
      {errors[name] && (
        <div className="form-error">Required</div>
      )}
    </Form.Group>
  );

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">INSTALL P1/TERMINAL MERCH</h4>
              <p className="form-desc">Please fill in all required details below</p>
            </div>
            <div className="form-main">
              <div className="form-main-content">
                <Form onSubmit={handleSubmit}>
                  <Question label="Install P1 standee_installed" name="standee_installed" />
                  <Question label="Install P1 door hanger" name="door_hanger_installed" />
                  <Question label="Install P1 QR troubleshooting sticker" name="qr_troubleshooting_sticker_installed" />
                  <Question label="Install P1 door sticker" name="door_sticker_installed" />

                  <div className="form-nav-btns">
                    <AppButton
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back
                    </AppButton>
                    <AppButton
                      type="submit"
                      variant="next"
                      className="form-btn variant-primary"
                    >
                    Next  →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default InstallP1TerminalMerch;